/**
 * Calendar Page - My Calendar View
 * Currently not implemented - use GoldenWings Calendar instead
 */

import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { CalendarOutlined } from '@ant-design/icons';

export const CalendarPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        padding: '48px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
      }}
    >
      <Result
        icon={<CalendarOutlined style={{ fontSize: 72, color: '#1890ff' }} />}
        title="My Calendar - Not Implemented Yet"
        subTitle="This feature is currently under development. Please use the GoldenWings Calendar in the meantime."
        extra={[
          <Button
            type="primary"
            key="goldenwings"
            onClick={() => navigate('/apps/goldenwings/calendar')}
          >
            Go to GoldenWings Calendar
          </Button>,
          <Button key="home" onClick={() => navigate('/')}>
            Back to Home
          </Button>,
        ]}
      />
    </div>
  );
};
